import React from 'react';
import { Button } from 'antd';
import { useOrderList } from 'hooks/order-management/order-list';
import SPButton from "../../../carRental/base/SPButton";

interface IComponentProps {
  data?: any;
  permission?: any;
}
const SPTableActionBar: React.FC<IComponentProps> = (props) => {
  const { data, permission } = props

  const { tableActionView, tableActionArrangeCar, tableActionArrangeDriver, tableActionPickupCar, tableActionReturnCar, tableActionAgreeRenew, tableActionRefuseRenew, tableActionFreeRenew } = useOrderList();

  // todo: hard code

  const onView = () => {
    tableActionView(data)
  };
  const onArrangeCar = () => {
    tableActionArrangeCar(data)
  }

  const onArrangeDriver = () => {
    tableActionArrangeDriver(data)
  }
  const onPickupCar = () => {
    tableActionPickupCar(data)
  }
  const onReturnCar = () => {
    tableActionReturnCar(data)
  }
  const onAgreeRenew = () => {
    tableActionAgreeRenew(data)
  };
  const onRefuseRenew = () => {
    tableActionRefuseRenew(data)
  };
  const onFreeRenew = () => {
    tableActionFreeRenew(data)
  }

  return (
    <>
      {/* 公共操作 */}
      <SPButton permissionKey='order-detail' permission={permission} type="link"  onClick={onView}>查看</SPButton>
      {/* 待取车 */}
      {
        data.order_status === 1 && <>
          <SPButton permissionKey='arrange-vehicle' permission={permission} type="link"  onClick={onArrangeCar}>{data.veh_info.veh_code ? '改排车' : '排车'}</SPButton>
          {data.veh_info.veh_code && (data.pickup_info.type !== 3 || data.return_info.type !== 3) && <SPButton permissionKey='arrange-driver' permission={permission} type="link"  onClick={onArrangeDriver}>排司机</SPButton>}
          {/* {data.veh_info.veh_code && <Button type="link"  onClick={onPickupCar}>取车</Button>} */}
          {(data.veh_info.veh_code && data.renewal_order?.status !== 1) && <SPButton permissionKey='freeRenewal' permission={permission} type="link" onClick={onFreeRenew}>免费续租</SPButton>}
          {data.renewal_order?.status === 1 && <SPButton permissionKey='renewal-agree' permission={permission} type="link"  onClick={onAgreeRenew}>续租同意</SPButton>}
          {data.renewal_order?.status === 1 && <SPButton permissionKey='renewal-reject' permission={permission} type="link"  onClick={onRefuseRenew}>续租拒绝</SPButton>}
        </>
      }
      {/* 待还车 */}
      {
        data.order_status === 2 && <>
          {(data.pickup_info.type !== 3 || data.return_info.type !== 3) && <SPButton permissionKey='arrange-vehicle' permission={permission}  type="link"  onClick={onArrangeDriver}>排司机</SPButton>}
          {/* <Button type="link"  onClick={onReturnCar}>还车</Button> */}
          {data.renewal_order?.status !== 1 && <SPButton permissionKey='freeRenewal' permission={permission} type="link" onClick={onFreeRenew}>免费续租</SPButton>}
          {data.renewal_order?.status === 1 && <SPButton type="link" permissionKey='renewal-agree' permission={permission}  onClick={onAgreeRenew}>续租同意</SPButton>}
          {data.renewal_order?.status === 1 && <SPButton type="link" permissionKey='renewal-reject' permission={permission}  onClick={onRefuseRenew}>续租拒绝</SPButton>}
        </>
      }
    </>
  );
};

export default SPTableActionBar;
